// core version + navigation, pagination modules:
// import SwiperCore, { Navigation, Pagination } from 'swiper/core';

// configure Swiper to use modules
// SwiperCore.use([Navigation, Pagination]);
/*[
    "assets/vendor/swiper.js",
    "assets/vendor/gsap.min.js",
    "assets/vendor/ScrollTrigger.min.js",
    "assets/scripts/defaults.js",
    "assets/scripts/menu.js",
    "assets/scripts/animations.js",
    "assets/scripts/modal.js",
    "assets/scripts/scripts.js"
]*/

import defaults from './defaults.js';
defaults();
import menu from './menu.js';
menu();
import modal from './modal.js';
modal();
import anchor from './anchor.js';
anchor();
import color from './color.js';
color();
